// extracted by mini-css-extract-plugin
export var count = "styles-module__count___xuAxm";